<template>
    <div v-if="profileInfo.email" class="item expmenu" v-exp-menu>
        <button class="overlay"><span class="icon fastic-close" role="button"></span></button>
        <button class="button">{{ profileInfo.firstLetters }}</button>
        <div class="exp profilecard">
            <div class="profile">
                <div class="avatar">{{ profileInfo.firstLetters }}</div>
                <div v-if="!profileInfo.isCompany" class="name">{{ profileInfo.name }} {{ profileInfo.surname }}</div>
                <div v-else class="name">{{ profileInfo.name }}</div>
                <div class="email">{{ profileInfo.email }}</div>
            </div>
            <div class="item"><a :href="routes.MyBeghelliDashboard_Dashboard" class="button">{{ localizer.get('App.MyBeghelli.Dashboard') }}</a></div>
            <div class="item"><a :href="routes.MyBeghelliOrder_OrderList" class="button">{{ localizer.get('App.Common.MyOrders') }}</a></div>
            <div class="item"><a :href="routes.MyBeghelliProfile_AccountEdit" class="button">{{ localizer.get('Account.Common.AccountSecurity') }}</a></div>
            <div class="item"><a :href="routes.MyBeghelliProfile_ProfileEdit" class="button">{{ localizer.get('Account.Common.PersonalData') }}</a></div>
            <div class="sep"></div>
            <div class="item" data-border="top"><app-accountlogout></app-accountlogout></div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onBeforeMount } from "vue";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";

const localizer = Localizer;
const routes = (window as any).App.routes;

const profileInfo = ref<any>({ email: null, isCompany: false });

onBeforeMount(async () => {
    await getData();
});

async function getData() {
    const result = (await Axios.post(routes.Account_User_GetUserInfo)).data;
    profileInfo.value.email = result.email;
    profileInfo.value.name = result.name;
    profileInfo.value.surname = result.surname;
    profileInfo.value.isCompany = result.isCompany;
    profileInfo.value.firstLetters = result.firstLetters;
}
</script>